'use strict';

/*
_RewardsController:

The controller calls endpoints that are necessary to create the 'Rewards' model and 
define rewards logic IE eligibility.
Rewards model is used for the crypto/rewards view. 
*/
function _RewardsController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ErrorController];

  this._errorInitialized = false;
  this._requestErrors = {}; // keep track of errors for parallel reward requests
  this._currentClass = null;

  // Promise
  this._rewardsTiersModelReady = $.Deferred(); // this.presenter.models.rewards
  this._cashbackModelReady = $.Deferred(); // this.presenter.models.rewards.cashback
  this._cryptoCashbackEligibilityModel = $.Deferred(); // this.presenter.models.rewards.cashback.crypto_tier_eligibilities

  this._accountIndexTiersAction = 'account.index_tiers';
  this._accountIndexCashbackAction = 'account.index_card_cashbacks';

  this.init = function () {
    this._super();
    this.history = new History();
    this.productSettings = new ProductSettings(this.presenter);

    this._createRewardsTierModel();

    /*
      When the required models are ready, call initPage() function of 
      everything that extends this controller -
      As of July 2021, those are RewardsTray.js and RewardsCashbackView.js
    */
    $.when(this._rewardsTiersModelReady, this._cashbackModelReady, this._cryptoCashbackEligibilityModel).done(this.initPage.bind(this));
  };

  this._createRewardsTierModel = function () {
    if (typeof this.presenter.models.rewards === 'undefined' || !this.presenter.models.rewards._initialized) {
      if (this.presenter.hasAction(this._accountIndexTiersAction)) {
        this.presenter.performAction(this._accountIndexTiersAction, null, this._onCreateRewardsTierModel.bind(this));
      } else {
        console.warn('cannot retrieve reward tiers: missing index tiers link');
      }
    } else {
      this.presenter.updateModel('rewards', null, this._onCreateRewardsTierModel.bind(this));
    }
  };

  this._onCreateCashbackModel = function (data, response) {
    // Checks for Connection issue
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.rewards = response;
      if (!this._errorInitialized || this.declaredClass !== this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: this._accountIndexCashbackAction }, { productLabel: 'Rewards' }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      this.presenter.createModel('rewards.cashback', { data: data });
      this._cashbackModelReady.resolve();
      this._setupCryptoCashbackEligibilityModel();
    } else {
      console.warn('_onCreateCashbackModel - Error calling ' + this._accountIndexCashbackAction + ' rel link:');
      console.warn(response);
      console.warn(data);
    }
  };

  this._onCreateRewardsTierModel = function (data, response) {
    // Checks for Connection issue
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.rewards = response;
      if (!this._errorInitialized || this.declaredClass !== this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: this._accountIndexTiersAction }, { productLabel: 'Rewards' }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      this.presenter.createModel('rewards', { data: data }, this._createCashbackModel.bind(this));
      this._rewardsTiersModelReady.resolve();
    } else {
      console.warn('_onCreateRewardsTierModel - Error calling ' + this._accountIndexTiersAction + ' rel link:');
      console.warn(response);
      console.warn(data);
    }
  };

  this._setupCryptoCashbackEligibilityModel = function () {
    var _this = this;

    var cashbackActiveTierId = this.presenter.getModelProperty('rewards.cashback.active_tier_id');

    this.getTierEligibility(cashbackActiveTierId, function (data, res) {
      var cashbackTier = _this.presenter.getModelProperty('rewards.tiers').find(function (tier) {
        return tier.id === cashbackActiveTierId;
      });
      _this.presenter.setModelProperty('rewards.cashback.crypto_tier_eligibilities', data);
      cashbackTier.setModelProperty('eligibility', data);
      _this._cryptoCashbackEligibilityModel.resolve();
    });
  };

  this._createCashbackModel = function () {
    if (this.presenter.hasAction(this._accountIndexCashbackAction)) {
      this.presenter.performAction(this._accountIndexCashbackAction, null, this._onCreateCashbackModel.bind(this));
    } else {
      console.warn('cannot retrieve rewards cashback: missing ' + this._accountIndexCashbackAction + ' rel link');
    }
  };

  this.getTierEligibility = function (id, callback) {
    var tiers = this.presenter.getModelProperty('rewards.tiers').find(function (tier) {
      return tier.id === id;
    });

    if (tiers && tiers.hasAction('get_tier_eligibility')) {
      tiers.performAction('get_tier_eligibility', null, function (data, res) {
        if (typeof callback === 'function') return callback(data, res);
      });
    } else {
      console.warn('cannot retrieve tiers eligibility: missing get_tier_eligibilty link');
      this._cryptoCashbackEligibilityModel.resolve();
    }
  };

  this.destroy = function () {
    this._super();
  };
}